import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import { useEffect, useState } from "react"

// Modal padrão pra ou tu cancelar ação ou continuar
export const BotaoComModalConfirmacao = ({titulo, texto, show, onHide, onContinue, onContinueLoads=false}) =>
{
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    async function executeAsync()
    {
      await onContinue()
      setLoading(false)
    }
    
    if(loading)
    {
      executeAsync()
    }
  }, [loading, onContinue])

  return (
      <Modal
        show={show}
        onHide={loading? null : onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {titulo}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {texto}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={onHide} disabled={loading}>Cancelar</Button>
          {
            loading?
            <Button variant="success" disabled>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            </Button>
            :
            <Button variant='success' 
              onClick={onContinueLoads? () => setLoading(true) : onContinue}>
              Continuar
            </Button>
          }
        </Modal.Footer>
      </Modal>
  );
}